
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './Components/Header';
import HomePage from './Components/HomePage/HomePage';
import UserCreate from './Components/UserCreate/UserCreate';
import UserLogin from './Components/UserLogin/UserLogin';
import PostCreate from './Components/PostCreate/PostCreate';
import UserPost from './Components/UserPost/UserPost';
import AllPost from './Components/AllPost/AllPost';
import Footer from './Components/Footer';
import AboutMe from './Components/AboutMe';

function App() {
  return (
     <>
         <Router>
           <Header/>
       <Routes>

          <Route exact path='/' element={<HomePage/>}/>
          <Route exact path='/create' element={<UserCreate/>}/>
          <Route exact path='/login' element={<UserLogin/>}/>
          <Route exact path='/userPost' element={<UserPost/>}/>
          <Route exact path='/allPost' element={<AllPost/>}/>
          <Route exact path='/post' element={<PostCreate/>}/>
          <Route exact path='/about' element={<AboutMe/>}/>
          {/* <Route exact path='/update' element={<Upade/>}/> */}
          <Route exact path='/*' element={<h1>Page not found</h1>}/>

       </Routes>
        <Footer/>
    </Router>
     </>
  );
}

export default App;
